import {SET_CUSTOMIZABLES, SET_CUSTOMIZABLES_DEFAULT} from '../actionTypes'
import {StyleSheet, css} from 'aphrodite';
import buildRadioStyles from './styles/radio';
import buildStickerTooltipStyles from './styles/stickerTooltip'

const initialState = {
    logo: `${process.env.REACT_APP_CDN_PATH}/LOGO_FIRMAME.svg`,
    logoSignup: `${process.env.REACT_APP_CDN_PATH}/LOGO_FIRMAME.svg`,
    imgSticker: `${process.env.REACT_APP_CDN_PATH}/images/es_sign_here.png`,
    imgSuccess: `${process.env.REACT_APP_CDN_PATH}/images/firmado.svg`,
    signing: `${process.env.REACT_APP_CDN_PATH}/images/firmando.svg`,
    loading: `${process.env.REACT_APP_CDN_PATH}/images/trabajando.svg`,
    title: process.env.REACT_APP_TITLE,
    showLabel: false,
    askForFeedback: true,
    hideConfirmation: false,
    palette: {
        dividerColor: '#e0e8f1',
        secondaryColor: '#00299f',
        lightSecondaryColor: '#fff',
        primaryText: '#5a5a5a',
        secondaryText: '#484848',
        contentBackground: '#fff',
        darkBackground: '#fff',
        lightBackground: '#fafafa',
        lightBackgroundSignup: '#f7fbff',
        secondaryAction: '#6c757d',
        mainAction: '#00299f',
        accentText: '#00299f',
        validColor: '#2b98f0',
        mobileTopBar: '#00299f',
        mobileBadge: '#FF0000',
        mobileTopBarText: '#FAFAFA',
        stickerBackground: '#D7E8FA',
        stickerRejectedBackground: '#ffd5d5',
        stickerInactive: '#000000',
        styles: StyleSheet.create({
            ...buildRadioStyles({color: '#00299f'}),
            ...buildStickerTooltipStyles({background: '#00299f'})
        })
    },
    customStyle: undefined,
    limited: false,
    companyComponents: 'Firmamex',
    firebaseConfig: {
        apiKey: "AIzaSyBIZn1_CCHZtzXiC8ycbz28vQjRRXIEdeM",
        authDomain: "app2-firmamex.firebaseapp.com",
        databaseURL: "https://app2-firmamex.firebaseio.com",
        projectId: "app2-firmamex",
        storageBucket: "app2-firmamex.appspot.com",
        messagingSenderId: "11150395071",
        appId: "1:11150395071:web:44ff59590a6ac6b24b280a",
        measurementId: "G-T181J1PHM0"
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case SET_CUSTOMIZABLES_DEFAULT: {
            const params = action.payload || {};
            document.title = initialState.title;

            const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = `${process.env.REACT_APP_CDN_PATH}/favicon/favicon-16x16.png`;
            document.getElementsByTagName('head')[0].appendChild(link);

            return {
                ...initialState, ...params, customStyle: false,
            }
        }
        case SET_CUSTOMIZABLES: {
            document.title = action.payload.title;
            const {palette, favicon, additionalConfig, ...rest} = action.payload;
            let conf = additionalConfig ? JSON.parse(additionalConfig) : {};

            let app2Firmado = conf.app2Firmado ? conf.app2Firmado : initialState.imgSuccess;
            let app2Firmando = conf.app2Firmando ? conf.app2Firmando : initialState.signing;
            let app2Cargando = conf.app2Cargando ? conf.app2Cargando : initialState.loading;
            let customLogo = conf.customLogo ? conf.customLogo : initialState.logo;
            let logoSignup = conf.customLogo ? conf.customLogo : initialState.logoSignup;

            if(action.customStylePresent && action.additionalConfPresent) {
                if(favicon) {
                    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                    link.type = 'image/x-icon';
                    link.rel = 'shortcut icon';
                    link.href = favicon;
                    document.getElementsByTagName('head')[0].appendChild(link);
                }

                return {
                    ...initialState,
                    ...rest,
                    imgSuccess: app2Firmado,
                    signing: app2Firmando,
                    loading: app2Cargando,
                    logo: customLogo,
                    logoSignup: logoSignup,
                    palette: {
                        ...initialState.palette,
                        ...palette,
                        styles: StyleSheet.create({
                            ...buildRadioStyles({color: palette.secondaryColor}),
                            ...buildStickerTooltipStyles({background: palette.secondaryColor})
                        })
                    },
                    limited: action.limited
                }
            } else if(action.additionalConfPresent) {


                return {
                    ...initialState,
                    imgSuccess: app2Firmado,
                    signing: app2Firmando,
                    loading: app2Cargando,
                    logo: customLogo,
                    logoSignup: logoSignup,
                    palette: {
                        ...initialState.palette,
                    },
                    limited: action.limited
                }
            } else if(action.customStylePresent) {
                const {palette, favicon, ...rest} = action.payload;

                if(favicon) {
                    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                    link.type = 'image/x-icon';
                    link.rel = 'shortcut icon';
                    link.href = favicon;
                    document.getElementsByTagName('head')[0].appendChild(link);
                }

                return {
                    ...initialState,
                    ...rest,
                    palette: {
                        ...initialState.palette,
                        ...palette,
                        styles: StyleSheet.create({
                            ...buildRadioStyles({color: palette.secondaryColor}),
                            ...buildStickerTooltipStyles({background: palette.secondaryColor})
                        })
                    },
                    limited: action.limited
                }
            } else {
                return state;
            }
        }
        default: {
            return state;
        }
    }

}
